import React from "react";
import ReactDom from "react-dom";
import FrameworkModal from "./FrameworkModal.jsx";

export default function renderFrameworkModal() {
  document.querySelectorAll(".js-framework-modal-mount").forEach((mount) => {
    const data = JSON.parse(mount.getAttribute("data-model"));

    const EE = mount.closest(".is-page-editor") ? true : false;

    ReactDom.render(<FrameworkModal {...data} editing={EE} />, mount);
  });
}
